module.exports = __webpack_public_path__ + "media/enterprise_powerlist/enterprise-powerlist-desktop-95a0dfdf.png";